module.exports = __webpack_public_path__ + "img/turksAndCaicos.3cc2ae56.jpg";